export function getOwnerEndpoint(self) {
    const { collection } = self;
    if (collection) {
        return getOwnerEndpoint(collection);
    }
    if (self._owner) {
        const { _endpoints } = self._owner;
        return _endpoints && _endpoints[self._ownerKey];
    }
}
export function createIOPromise(initialize) {
    let resolve, reject, onAbort;
    function abort(fn) {
        onAbort = fn;
    }
    const promise = new Promise((a_resolve, a_reject) => {
        reject = a_reject;
        resolve = a_resolve;
        initialize(resolve, reject, abort);
    });
    promise.abort = () => {
        onAbort ? onAbort(resolve, reject) : reject(new Error("I/O Aborted"));
    };
    return promise;
}
export function startIO(self, promise, options, thenDo) {
    // abortIO(self);
    self._ioPromise = promise
        .then(resp => {
        self._ioPromise = null;
        const result = thenDo ? thenDo(resp) : resp;
        triggerAndBubble(self, 'sync', self, resp, options);
        return result;
    })
        .catch(err => {
        self._ioPromise = null;
        triggerAndBubble(self, 'error', self, err, options);
        throw err;
    });
    self._ioPromise.abort = promise.abort;
    return self._ioPromise;
}
export function abortIO(self) {
    if (self._ioPromise && self._ioPromise.abort) {
        self._ioPromise.abort();
        self._ioPromise = null;
    }
}
export function triggerAndBubble(eventSource, ...args) {
    eventSource.trigger.apply(eventSource, args);
    const { collection } = eventSource;
    collection && collection.trigger.apply(collection, args);
}
//# sourceMappingURL=io-tools.js.map
